export const topFeatures = [
  {
    id: 1,
    icon: '📞',
    title: 'WiFi Calling - No SIM Required',
    description: 'Free calling over WiFi with no data or SIM card needed. No WiFi? Switch to phone or WhatsApp instantly. Works on tablets—no phone bill required.',
    featured: true,
  },
  {
    id: 2,
    icon: '🖥️',
    title: 'Screen Sharing & Guide Mode',
    description: 'Share your screen for help, and contacts can draw directly on it to point you in the right direction. Perfect for tech support and guidance.',
    unique: true,
    featured: true,
    showcased: true,
  },
  {
    id: 3,
    icon: '🚨',
    title: 'Complete Emergency System',
    description: 'One-touch emergency button shares your location and calls primary contacts instantly. Comprehensive safety features for complete peace of mind.',
    featured: true,
  },
  {
    id: 4,
    icon: '🔊',
    title: 'Ringtone Volume Boost for Clear Hearing',
    description: 'Amplify ringtone volume so you never miss a call or alert. One-tap volume boost for anyone hard of hearing—loud, clear, and impossible to miss.',
    featured: true,
  },
  {
    id: 5,
    icon: '🌅',
    title: 'Good Morning & Goodnight Check-Ins',
    description: 'Simple one-tap buttons to let everyone know you\'re okay. Share your location or send daily wellness updates effortlessly.',
  },
  {
    id: 6,
    icon: '🔋',
    title: 'Easy Volume & Battery Controls',
    description: 'Large sliders and buttons for volume control. Visual and audio battery reminders ensure you never run out of power unexpectedly.',
  },
  {
    id: 7,
    icon: '📄',
    title: 'Smart Document Scanner',
    description: 'Scan bills, medical letters, and documents. Have them read aloud to you and automatically saved in the right place. Never lose important paperwork again.',
  },
  {
    id: 8,
    icon: '📅',
    title: 'Auto Calendar & Volunteer System',
    description: 'Appointments automatically added to your calendar. Selected family members can see them and volunteer to bring you to the doctor or pharmacy.',
  },
  {
    id: 9,
    icon: '👥',
    title: 'Activity Sharing',
    description: 'Share your activity so family knows when you have visitors or what\'s happening each week. Control your privacy—be as private or open as you wish.',
  },
  {
    id: 10,
    icon: '🔤',
    title: 'Large Text & Easy Navigation',
    description: 'Extra-large, easy-to-read text and simple navigation designed for everyone. No confusing menus or tiny buttons—everything is clear and accessible.',
  },
  {
    id: 11,
    icon: '📻',
    title: 'Built-In Radio & Entertainment',
    description: 'Search for favorite radio stations and save them for one-click listening. Entertainment and news at your fingertips.',
  },
];

export const valueProps = {
  unified: [
    'Free WiFi calling with no phone bill—works on any phone or tablet',
    'Ringtone volume boost for hard of hearing—never miss a call',
    'Large, easy-to-read text and simple navigation for everyone',
    'Scan documents and have them read aloud—organised automatically',
    'One-tap emergency alerts notify your entire care circle',
    'See appointments and volunteer to help with rides or errands',
    'Share your daily activity or stay completely private—you control it',
    'Guide loved ones by drawing on their screen during calls',
    'Good morning and goodnight check-ins for peace of mind',
    'Location sharing at the touch of a button',
    'Built-in radio, battery reminders, and easy volume controls',
  ],
};
